import { Outlet } from "react-router";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { overlayVariants } from "../../../utils/framerMotion";
import Sidebar from "../common/sidebar";
import Navbar from "../common/navbar";

const HomeLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  return (
    <div className="flex min-h-screen w-full bg-[#0b0a07] text-[#d8d2c4]">
      {/* Mobile overlay */}
      <AnimatePresence>
        {isSidebarOpen && (
          <motion.div
            variants={overlayVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className="fixed inset-0 bg-black/50 z-20 lg:hidden backdrop-blur-sm"
            onClick={toggleSidebar}
          />
        )}
      </AnimatePresence>

      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        onCollapseChange={setIsSidebarCollapsed}
      />

      {/* Main content — margin matches sidebar width exactly */}
      <div
        className={`flex flex-col flex-1 min-w-0 transition-all duration-300 ${isSidebarCollapsed ? "lg:ml-16" : "lg:ml-64"
          }`}
      >
        <Navbar toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />

        <main className="flex-1 p-3 overflow-x-auto bg-[#0b0a07]">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default HomeLayout;